import React, { useState } from "react";
import { Col, Row, Segmented } from "antd";
import { useParams } from "react-router-dom";
import FeedingCalendar from "../Calendar/FeedingCalendar";
import { translate } from "../../locale";
import RangeForm from "../Charts/RangeForm";
import PropTypes from "prop-types";

const PatientFeedingTable = ({ feedingSubmodules }) => {
  const [selectedSegment, setSelectedSegment] = useState("calendar");
  const { username } = useParams();

  const handleChangeItem = (value) => {
    setSelectedSegment(value);
  };
  return (
    <>
      <Row className="mt-6 mb-14" gutter={40}>
        <Col>
          <Segmented
            options={[
              { value: "calendar", label: "Calendario" },
              { value: "range", label: "Rangos" },
            ]}
            onChange={handleChangeItem}
          ></Segmented>
        </Col>
      </Row>
      <Row className="relative mb-14 w-full">
        {selectedSegment === "calendar" && (
          <FeedingCalendar feedingSubmodules={feedingSubmodules} />
        )}
        {selectedSegment === "range" && (
          <RangeForm
            initialValues={{
              patient: username,
              type: "hs_alimentacion",
              max_value_alert: 24,
              max_value: 12,
            }}
            title={translate("Rango de alimentación por horas")}
            onlyMax={true}
          />
        )}
      </Row>
    </>
  );
};
PatientFeedingTable.propTypes = {
  feedingSubmodules: PropTypes.array.isRequired,
};

export default PatientFeedingTable;
